import type { EinvoiceAddressesResponse } from 'types/einvoiceAddress';
import { objectToQueryParams } from 'utils/linkUtil';
import { portalAPI } from './portalAPI';

const APIEinvoiceAddressSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        searchEinvoiceAddresses: builder.query<
            EinvoiceAddressesResponse,
            { page?: number; size?: number; search?: string }
        >({
            query: ({ page = 0, size = 20, search }) => {
                const params = objectToQueryParams({
                    page,
                    size,
                    ...(search && { search }),
                });
                return `/v1/einvoice-addresses/search${params}`;
            },
        }),
    }),
    overrideExisting: false,
});

export const { useLazySearchEinvoiceAddressesQuery } = APIEinvoiceAddressSlice;
